// @flow

import type {Company, Language, RiskRating, RiskSummary, Paging, CompaniesSortOption, CompaniesSortBy} from '@/types'

import React from 'react'
import {connect} from 'react-redux'
import {mergeAll, path} from 'ramda'
import {appSelectors, portfoliosActions, portfoliosSelectors, uiActions} from '@/store'
import Pagination from '@/controls/pagination'

import RiskFilter from './risk-filter'
import List from './list'
import './index.css'

type Props = {
  companies: Array<Company>,
  companiesCount: number,
  countryCode: string,
  l: Language,
  fetchPortfolioCompaniesByRiskType: () => void,
  paging: Paging,
  portfolioName: string,
  riskSummary: RiskSummary,
  riskTypeChange: (any) => void,
  setPortfolioCompaniesByRiskTypePageNumber: (number) => void,
  setPortfolioCompaniesByRiskTypeSortOptions: (CompaniesSortOption) => void,
  showCompanyReport: (string) => void,
  shownRiskRating: RiskRating,
  sortOptions: CompaniesSortOption,
  toggleRiskFilter: (RiskRating) => void,
}

const pageChange = (props) => (pageNumber) => {
  props.setPortfolioCompaniesByRiskTypePageNumber(pageNumber - 1)
  props.fetchPortfolioCompaniesByRiskType()
}

const determineSortOptions = (sortOptions: CompaniesSortOption) => (sortBy: CompaniesSortBy) => {
  const currSortBy = sortOptions.sortBy
  const currSortDir = sortOptions.sortDir
  let nextSortOptions = {}
  nextSortOptions['sortBy'] = sortBy
  if (sortBy === currSortBy) {
    nextSortOptions['sortDir'] = currSortDir === 'asc' ? 'desc' : 'asc'
  } else {
    nextSortOptions['sortDir'] = 'asc'
  }
  return nextSortOptions
}

const fetchCompaniesSortBy = (props) => (sortBy: CompaniesSortBy) => {
  props.setPortfolioCompaniesByRiskTypePageNumber(0)
  props.setPortfolioCompaniesByRiskTypeSortOptions(determineSortOptions(props.sortOptions)(sortBy))
  props.fetchPortfolioCompaniesByRiskType()
}

const renderRiskTable = (props) =>
  <div>
    <div className="row">
      <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
        <RiskFilter
          l={props.l}
          riskSummary={props.riskSummary}
          shownRiskRating={props.shownRiskRating}
          riskTypeChange={props.riskTypeChange}
        />
      </div>
    </div>
    <div className="row">
      <div className="col-xs-12">
        <List companies={props.companies}
          l={props.l}
          shownRiskRating={props.shownRiskRating}
          showCompanyReport={props.showCompanyReport}
          sortBy={fetchCompaniesSortBy(props)}
          currSortOptions={props.sortOptions}
          countryCode={props.countryCode}
        />
        {
          props.companiesCount > props.paging.pageSize ? <Pagination
            activePage={props.paging.pageNumber + 1}
            pageSize={props.paging.pageSize}
            totalItems={props.companiesCount}
            onChange={pageChange(props)}
          /> : false
        }
      </div>
    </div>
  </div>

const CompaniesAnalysis = (props: Props) => renderRiskTable(props)

const mapStateToProps = (state) => ({
  companies: portfoliosSelectors.getActivePortfolioCompaniesByRiskType(state),
  companiesCount: portfoliosSelectors.getActivePortfolioCompaniesByRiskTypeCount(state),
  paging: state.ui.companiesByRiskTypePaging,
  portfolioName: portfoliosSelectors.getActivePortfolioName(state),
  riskSummary: portfoliosSelectors.getActivePortfolioRiskSummary(state),
  shownRiskRating: path(['ui', 'shownRiskRating'], state),
  sortOptions: path(['ui', 'companiesByRiskTypeSortOptions'], state),
  toggleRiskFilter: path(['ui', 'toggleRiskFilter'], state),
  l: appSelectors.getL(state),
  countryCode: state.app.user.countryCode,
})

export default connect(
  mapStateToProps,
  mergeAll([portfoliosActions, uiActions]),
)(CompaniesAnalysis)



// WEBPACK FOOTER //
// ./src/views/analysis-page/companies/index.js